var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSettingsIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.9995C8.75 10.7569 9.75736 9.74953 11 9.74953C12.2426 9.74953 13.25 10.7569 13.25 11.9995C13.25 13.2422 12.2426 14.2495 11 14.2495C9.75736 14.2495 8.75 13.2422 8.75 11.9995Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58523 3.23181C8.56564 -0.203571 13.4342 -0.203572 14.4147 3.23181C14.7184 4.29621 15.812 4.92757 16.8857 4.65844C20.351 3.78981 22.7853 8.00615 20.3004 10.5729C19.5305 11.3682 19.5305 12.6309 20.3004 13.4262C22.7853 15.9929 20.351 20.2092 16.8857 19.3406C15.812 19.0715 14.7184 19.7028 14.4147 20.7673C13.4342 24.2026 8.56564 24.2026 7.58523 20.7673C7.28146 19.7028 6.18792 19.0715 5.11423 19.3406C1.6489 20.2092 -0.785401 15.9929 1.69952 13.4262C2.46944 12.6309 2.46944 11.3682 1.69952 10.5729C-0.785401 8.00615 1.6489 3.78981 5.11423 4.65844C6.18792 4.92757 7.28146 4.29621 7.58523 3.23181ZM11 8.24953C8.92893 8.24953 7.25 9.92846 7.25 11.9995C7.25 14.0706 8.92893 15.7495 11 15.7495C13.0711 15.7495 14.75 14.0706 14.75 11.9995C14.75 9.92846 13.0711 8.24953 11 8.24953Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSettingsIconSelected);
export default __webpack_public_path__ + "static/media/menu-settings-icon-selected.8c2e9213.svg";
export { ForwardRef as ReactComponent };